import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { API_ENDPOINTS } from '../constants/api-endpoints';
import { ApiResponse } from '../models/api-response.models';
import { unwrapApiResponse } from '../utils/api-response';
import { ApiService } from './api.service';

export interface Faq {
  id: string;
  question: string;
  answer: string;
  category: string;
  displayOrder: number;
  isPublished: boolean;
  updatedAt: string;
}
export type SaveFaq = Omit<Faq, 'id' | 'updatedAt'>;
@Injectable({ providedIn: 'root' })
export class FaqsService {
  private readonly api = inject(ApiService);
  list(): Observable<Faq[]> {
    return this.api
      .get<ApiResponse<{ faqs: Faq[] }> | { faqs: Faq[] }>(
        API_ENDPOINTS.faqs.admin,
        undefined,
        'marketplace',
      )
      .pipe(map((r) => unwrapApiResponse(r).faqs ?? []));
  }
  create(body: SaveFaq): Observable<Faq> {
    return this.api
      .post<ApiResponse<{ faq: Faq }> | { faq: Faq }, SaveFaq>(
        API_ENDPOINTS.faqs.admin,
        body,
        'marketplace',
      )
      .pipe(map((r) => unwrapApiResponse(r).faq));
  }
  update(id: string, body: SaveFaq): Observable<Faq> {
    return this.api
      .put<ApiResponse<{ faq: Faq }> | { faq: Faq }, SaveFaq>(
        API_ENDPOINTS.faqs.byId(id),
        body,
        'marketplace',
      )
      .pipe(map((r) => unwrapApiResponse(r).faq));
  }
  delete(id: string): Observable<void> {
    return this.api.delete<void>(API_ENDPOINTS.faqs.byId(id), 'marketplace');
  }
}
